import { cn } from '@blockworks/ui/utils';

import PauseIcon from './icons/pause-icon';
import PlayIcon from './icons/play-icon';

interface PlayButtonProps {
    player: {
        toggle: () => void;
        playing: boolean;
    };
    size?: 'large' | 'medium' | 'small';
    onClick?: () => void;
}

export const PlayButton = ({ player, size = 'large', onClick = () => {} }: PlayButtonProps) => {
    const classNameOptions = {
        large: 'h-18 w-18 focus:ring focus:ring-offset-4',
        medium: 'h-14 w-14 focus:ring-2 focus:ring-offset-2',
        small: 'h-10 w-10 focus:ring-2 focus:ring-offset-2',
    };
    // @ts-ignore
    const className: string = classNameOptions[size || 'large']! as string;

    return (
        <button
            type="button"
            className={cn(
                'group relative flex flex-shrink-0 items-center justify-center rounded-full bg-slate-700 hover:bg-slate-900 focus:outline-none focus:ring-slate-700',
                className,
            )}
            onClick={() => {
                player.toggle();
                onClick && onClick();
            }}
            aria-label={player.playing ? 'Pause' : 'Play'}
        >
            <div className="absolute -inset-3 md:hidden" />
            {player.playing ? (
                <PauseIcon
                    className={cn(
                        'fill-white group-active:fill-white/80',
                        // @ts-ignore
                        {
                            large: 'h-7 w-7',
                            medium: 'h-5 w-5',
                            small: 'h-4 w-4',
                        }[size],
                    )}
                />
            ) : (
                <PlayIcon
                    className={cn(
                        'fill-white group-active:fill-white/80',
                        // @ts-ignore
                        {
                            large: 'h-9 w-9',
                            medium: 'h-7 w-7',
                            small: 'h-5 w-5',
                        }[size],
                    )}
                />
            )}
        </button>
    );
};
